var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"VModal-fade"}},[(_vm.isOpen)?_c('div',{staticClass:"VModal-overlay",on:{"click":_vm.closeModal}},[_c('div',{class:[
        'VModal',
        _vm.size,
        {
          'VModal-scroll': _vm.isScrollable,
          'VModal-open': _vm.isOpen,
          'VModal--card-mobile': _vm.cardOnMobile
        }
      ],on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"VModal-header"},[_c('h2',{staticClass:"VModal-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.closeButton)?_c('button',{staticClass:"VModal-close",on:{"click":_vm.closeModal}},[_c('icon',{attrs:{"name":"close-modal"}})],1):_vm._e()]),_vm._v(" "),(_vm.isOpen)?_c('div',{ref:"modalBody",staticClass:"VModal-body",class:{ 'VModal-body-scroll': _vm.isScrollable },on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2):_vm._e()])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }